// let sportUrl = process.env.NODE_ENV === 'production' ?
//  'http://sc.ttmna.com' + '/api/v1' : '/sportapi' 
let sportUrl = '/sportapi' 
let sportUrl1 = '/sportapi1' 
// window.newsports 测试体育api地址http://sportsapi.zbitcloud.com/api/v1 
// 正式地址https://sportsapi.ycdnedu.com/api/v1

// 5.14 替换体育接口  https://sportsapi.ycdnedu.com =》http://sc.ttmna.com/api

export default {
  getMatchAllList: sportUrl + '/basketball/getMatchAllList',
  footballList: sportUrl + '/football/getMatchAllList',
  liveSportsList: sportUrl + '/live/getRandomList',
  liveSportsPcList:sportUrl + '/live/getPcLiveList',
  sportgetHomeData: sportUrl1 + '/basketball/getSlideEvents',
  clickStatistics:sportUrl + '/statistics/click',
  [sportUrl + '/statistics/click']: {specil: true},
  [sportUrl + '/live/getPcLiveList']: {specil: true}
}




// WEBPACK FOOTER //
// ./src/http/api.js